import { useDotLegalBreadCrumbs } from "@dotlegal/dotlegal-ui-components";
import CasePage, { CasePageProps } from "../../core/cases/CasePage";

function Copyrights(props: CasePageProps) {
    useDotLegalBreadCrumbs([{ name: "Copyrights" }]);
    return <CasePage {...props} />;
}

export default Copyrights;
